import type { ConsultantKpiObjectives } from "./consultant-kpi-objectives";

/** Fallback consultant KPI targets when the business unit has no configured objectives. */
export const consultantKpiDefaultObjectives: Record<"week" | "month", ConsultantKpiObjectives> = {
  week: {
    talentCalls: 100,
    temporaryWorkersOnPlanning: 50,
    fullTimeEquivalent: 45,
    occupancyPercent: 90,
    coefficient: 2.1,
    billedHourlyRate: 40,
    newCompanyMissions: 1,
    existingCompanyMissions: 3,
    newTalentPlacements: 1,
    existingTalentPlacements: 3,
    firstContractStarts: 3,
    recentBenchReplacements: 1,
    dormantBenchReactivations: 1,
    planningRetentionPercent: 95,
    netMargin: 15000,
    netMarginRate: 12,
  },
  month: {
    talentCalls: 400,
    temporaryWorkersOnPlanning: 50,
    fullTimeEquivalent: 45,
    occupancyPercent: 90,
    coefficient: 2.1,
    billedHourlyRate: 40,
    newCompanyMissions: 4,
    existingCompanyMissions: 13,
    newTalentPlacements: 3,
    existingTalentPlacements: 13,
    firstContractStarts: 14,
    recentBenchReplacements: 4,
    dormantBenchReactivations: 2,
    planningRetentionPercent: 95,
    netMargin: 15000,
    netMarginRate: 12,
  },
};
